const MuiButton = {
    root: {
        borderRadius: '12px',
        fontSize: '16px',
        '&$contained': {
            border: '1px solid white',
        },
        '&$contained:not($containedPrimary):not($containedSecondary)': {
            fontWeight: 600,
        },
        '&$contained:not($containedPrimary):not($containedSecondary):not($disabled)': {
            backgroundColor: 'white',
        },
        '&$text': {
            color: 'white',
        },
        // White button on white background
        '&$outlined': {
            border: '1px solid black',
            backgroundColor: 'white',
            color: 'black',
            
        },
        '&$outlined:not($containedPrimary):not($containedSecondary)': {
            fontWeight: 600,
        },
    },
};

export default MuiButton;
